// ============================================================================
// Pricing Service
// Manages site-specific pricing
// ============================================================================

import {
  Pricing,
  PricingCreate,
  PricingUpdate,
} from '../types/site';
import { fetchWithAuth } from './auth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8004/api';

// ============================================================================
// Site Pricing CRUD
// ============================================================================

export async function getSitePricing(siteId: number): Promise<Pricing[]> {
  const params = new URLSearchParams({ site_id: siteId.toString() });
  return fetchWithAuth(`${API_BASE_URL}/pricings/?${params}`);
}

export async function createPricing(data: PricingCreate): Promise<Pricing> {
  return fetchWithAuth(`${API_BASE_URL}/pricings/`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updatePricing(pricingId: number, data: PricingUpdate): Promise<Pricing> {
  return fetchWithAuth(`${API_BASE_URL}/pricings/${pricingId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}

export async function deletePricing(pricingId: number): Promise<void> {
  return fetchWithAuth(`${API_BASE_URL}/pricings/${pricingId}`, {
    method: 'DELETE',
  });
}

// ============================================================================
// Named Export Object
// ============================================================================

export const pricingService = {
  getSitePricing,
  createPricing,
  updatePricing,
  deletePricing,
};

export default pricingService;
